import type { IdTokenClaims } from "@azure/msal-browser";

export enum StatusEnum {
  Initial = "Initial",
  Loading = "Loading",

  Succeeded = "Succeeded",
  Failed = "Failed",
}

export enum LoginStatus {
  Logged = "Logged",
  NotLogged = "NotLogged",
  Error = "Error",
}

export enum AuthenticationSteps {
  NotStarted = "NotStarted",
  Init = "Init",
  InitComplete = "InitComplete",
  Login = "Login",
  LoginError = "LoginError",
  LoginComplete = "LoginComplete",
  HandlingRedirect = "HandlingRedirect",
  Logout = "Logout",
  LogoutComplete = "LogoutComplete",
  LogoutError = "LogoutError",
}

export type UserAccountInfo = {
  username: string;
  permissions: string[] | null;
  groups: string[] | null;
  idTokenClaims: IdTokenClaims | undefined;
  tenantId: string | null;
  tenants: string[] | undefined;
  email: string | undefined;
};
export type AuthStoreType = {
  //To be implemented with needed infos about the user depending on the situation.
  userInfo: UserAccountInfo | null;
  token: string | null;
};

export type AccountInfoType = {
  authorityType: string;
  environment: string;
  homeAccountId: string;
  idToken: string;
  idTokenClaims: IdTokenClaims; // Reuse the previously defined AuthTokenType
  localAccountId: string;
  name: string;
  nativeAccountId?: string; // Optional field
  tenantId: string;
  tenantProfiles: Map<string, TenantProfileType>;
};

export type TenantProfileType = {
  isHomeTenant: boolean;
  localAccountId: string;
  name: string;
  tenantId: string;
};
